// extracted by mini-css-extract-plugin
export default {"-large":"ncUG0q8EZ7_6PX1JOKFl","container":"sjR5Qcr3CCkkP0YOTVmi","colorPaletteContainer":"M5qUu_MserYXAJfs3xEQ","icon":"wAHrPLHBKS9xmvgG4rah"};